import heatmapTypes from "../../container/heatmapTypes";

const getOuterWallElement = (floorData) => {
    return floorData.floorElements.find(e => e.type === heatmapTypes.elementTypes.OUTERWALL && e.floorId === floorData.activeFloor);
}

export {
    getOuterWallElement
}